import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Scrollbars from "react-custom-scrollbars";

import "./Box.scoped.scss";

const Box = ({ header = "", children }) => {
	const tab = useSelector(store => store.box.tab);
	const dispatch = useDispatch();

	const hide = () => dispatch({ type: "CHANGE_BOX_TAB", tab: null });

	return (
		<div className={`box ${tab === null && "box--hidden"}`}>
			<Scrollbars
				className="scroll_container"
				autoHeight={true}
				autoHeightMax="45vh"
				hideTracksWhenNotNeeded={true}
				renderTrackVertical={props => <div {...props} className="track_vertical" />}
				renderThumbVertical={props => <div {...props} className="thumb_vertical" />}
			>
				<div className="header text_center">{header}</div>
				<div className="content">{children}</div>
			</Scrollbars>

			<div className="collapse text_center" onClick={hide}>
				<i className="fas fa-angle-up" />
			</div>
		</div>
	);
};

export default Box;
